import { Box, BoxProps, styled } from '@mui/material'

export const dinoTableClasses = {
  root: 'DinoTable-root',
  whiteSpacePre: 'DinoTable-white-space-pre-wrap'
}

export const TableStyled = styled(({ children, ...p }: BoxProps) => (
  <Box {...p}>
    <div>{children}</div>
  </Box>
))({
  flex: 1,
  position: 'relative',
  '& > div': {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    overflowY: 'auto'
  },
  '.MuiDataGrid-root': {
    '--unstable_DataGrid-radius': 0,
    overflow: 'hidden'
  },
  [`.MuiDataGrid-cell.${dinoTableClasses.whiteSpacePre} .MuiDataGrid-cellContent`]: {
    whiteSpace: 'pre'
  },
  [`.MuiTablePagination-root p`]: {
    marginBottom: 0
  }
})
